import { type SVGProps } from "react";

export const SBPIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    {...props}
  >
    <path
      d="M6.68582 9.99768L4.3066 11.358L2.09668 15.1534L11.1057 9.99768H6.68582Z"
      fill="#8F4794"
    />
    <path
      d="M13.4846 6.11169L11.1054 7.47203L8.89551 11.2674L17.9045 6.11169H13.4846Z"
      fill="#E40646"
    />
    <path
      d="M11.1054 4.75139L8.89551 0.956055V8.73265V11.2674V19.044L11.1054 15.2487V4.75139Z"
      fill="#F9B429"
    />
    <path
      d="M8.89551 0.956055L11.1054 4.75139L13.4846 6.11173H17.9045L8.89551 0.956055Z"
      fill="#EF8019"
    />
    <path
      d="M8.89551 8.73254V19.0439L11.1054 15.2486V12.5279L8.89551 8.73254Z"
      fill="#78B72A"
    />
    <path
      d="M13.4846 13.8883L11.1054 15.2486L8.89551 19.044L17.9045 13.8883H13.4846Z"
      fill="#00853F"
    />
    <path
      d="M2.09668 4.84656V15.1534L4.3066 11.3626V8.63736L2.09668 4.84656Z"
      fill="#5B57A2"
    />
    <path
      d="M8.89574 8.73259L8.90031 8.73712L2.09668 4.84656L4.3066 8.63736L13.4849 13.8883H17.9047L8.89574 8.73259Z"
      fill="#0698D6"
    />
  </svg>
);
